<div class="tw-flex tw-items-center tw-gap-[10px] wo-contact-support" [class.expanded]="expanded">
  <iss-icon
    name="support"
    class="tw-w-[24px] tw-min-w-[24px] tw-h-[24px] tw-min-h-[24px]"
    [tuiHint]="'Central Waste Team'"
  />
  <div class="tw-overflow-hidden tw-overflow-ellipsis tw-whitespace-nowrap tw-font-[600]">
    Central Waste Team
  </div>
</div>

<iss-side-nav-menu-item
  *ngIf="phone"
  [title]="phone"
  (click)="openPhone()"
  iconName="phone"
/>
<iss-side-nav-menu-item
  [title]="email"
  (click)="openEmail()"
  iconName="email"
/>
<iss-side-nav-menu-item
  *ngIf="supportLink"
  [title]="'IT Service Desk'"
  (click)="openSupport(supportLink)"
  iconName="ticket"
/>
